const _items = [
  { text: '', value: undefined },
  { text: '自宅', value: '自宅' },
  { text: '主要な勤務先', value: '主要な勤務先' },
  { text: 'その他', value: 'その他' },
]

export default {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data() {
    return {
      destinationItems: _items,
    }
  },
}
